"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dashboard = require("@/api/dashboard.js");
var _index = _interopRequireDefault(require("@/components/echartsNew/index"));
var _index2 = _interopRequireDefault(require("@/components/ButtonTimePicker/index"));
var _index3 = _interopRequireDefault(require("@/components/StatisticsDataCardList/index"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'productStatistic',
  components: {
    echartsNew: _index.default,
    ButtonTimePicker: _index2.default,
    StatisticsDataCardList: _index3.default
  },
  mixins: [],
  props: {},
  data: function data() {
    return {
      startTime: '',
      // 开始时间
      endTime: '',
      // 结束时间
      productStatisticsData: [],
      // 商品统计数据
      productLineLoading: true,
      // 商品折线统计图是否加载
      productCategoryLoading: true,
      // 商品分类饼图图是否加载
      productTypeLoading: true,
      // 商品类型饼图图是否加载
      style: {
        height: '320px'
      },
      // 商品线形图选项
      productLineOption: {
        // 图像位置
        grid: {
          top: 50,
          left: 0,
          right: 50,
          bottom: 40,
          containLabel: true
        },
        color: ['#5B8FF9', '#5AD8A6', '#F6BD16', '#A78BFA'],
        // 指针数据显示
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        // 图例
        legend: {
          top: 10,
          left: 'center',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          data: ['商品浏览量', '收藏量', '下单量', '支付量']
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: '#E5E8EF'
            }
          },
          axisLabel: {
            color: '#666'
          },
          data: []
        },
        yAxis: {
          type: 'value',
          name: '数量',
          min: 0,
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: '#F0F0F0'
            }
          },
          axisLabel: {
            color: '#666',
            margin: 30
          }
        },
        series: [{
          name: '商品浏览量',
          type: 'line',
          smooth: true,
          symbol: 'none',
          symbolSize: '8',
          lineStyle: {
            width: 2
          },
          data: []
        }, {
          name: '收藏量',
          type: 'line',
          smooth: true,
          symbol: 'none',
          symbolSize: '8',
          lineStyle: {
            width: 2
          },
          data: []
        }, {
          name: '下单量',
          type: 'line',
          smooth: true,
          symbol: 'none',
          symbolSize: '8',
          lineStyle: {
            width: 2
          },
          data: []
        }, {
          name: '支付量',
          type: 'line',
          smooth: true,
          symbol: 'none',
          symbolSize: '8',
          lineStyle: {
            width: 2
          },
          data: []
        }]
      },
      // 商品分类饼图选项
      productCategoryOption: {
        title: {
          text: '商品分类',
          left: 0,
          top: 10,
          textStyle: {
            fontSize: 18,
            fontWeight: 600
          }
        },
        color: ['#3B82F6', '#34D399', '#60A5FA', '#F59E0B', '#FB923C', '#EF4444', '#A78BFA', '#F472B6', '#C084FC'],
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 0,
          top: 50,
          icon: 'circle'
        },
        series: [{
          name: '商品分类',
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['60%', '55%'],
          avoidLabelOverlap: true,
          label: {
            show: true,
            position: 'outside',
            formatter: '{b}'
          },
          labelLine: {
            show: true,
            length: 14,
            length2: 10,
            smooth: true
          },
          data: []
        }]
      },
      // 商品类型饼图选项
      productTypeOption: {
        title: {
          text: '商品类型',
          left: 0,
          top: 10,
          textStyle: {
            fontSize: 18,
            fontWeight: 600
          }
        },
        color: ['#3B82F6', '#34D399', '#60A5FA', '#F59E0B', '#FB923C', '#EF4444', '#A78BFA', '#F472B6', '#C084FC'],
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 0,
          top: 50,
          icon: 'circle'
        },
        series: [{
          name: '商品类型',
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['60%', '55%'],
          avoidLabelOverlap: true,
          label: {
            show: true,
            position: 'outside',
            formatter: '{b}'
          },
          labelLine: {
            show: true,
            length: 14,
            length2: 10,
            smooth: true
          },
          data: []
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    // 获取商品分类饼图数据
    this.getProductCategoryPieData();
    // 获取商品类型饼图数据
    this.getProductTypePieData();
  },
  destoryed: function destoryed() {},
  methods: {
    checkPermi: _permission.checkPermi,
    // 获取商品统计数据
    getProductStatisticsData: function getProductStatisticsData() {
      var _this = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getProductStatisticsDataApi)(param).then(function (res) {
        _this.productStatisticsData = res;
      }).catch(function (err) {
        _this.$message.error(err.msg || '获取商品统计数据失败');
      });
    },
    // 获取商品折线图数据
    getProductLineData: function getProductLineData() {
      var _this2 = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getProductLineDataApi)(param).then(function (res) {
        var xAxis = [],
          visitVolume = [],
          collectionVolume = [],
          orderVolume = [],
          paidVolume = [];
        res.forEach(function (item, index) {
          xAxis.push(item.date);
          visitVolume.push(item.visitVolume);
          collectionVolume.push(item.collectionVolume);
          orderVolume.push(item.orderVolume);
          paidVolume.push(item.paidVolume);
        });
        _this2.productLineOption.xAxis.data = xAxis;
        _this2.productLineOption.series[0].data = visitVolume;
        _this2.productLineOption.series[1].data = collectionVolume;
        _this2.productLineOption.series[2].data = orderVolume;
        _this2.productLineOption.series[3].data = paidVolume;
        _this2.productLineLoading = false;
      }).catch(function (err) {
        _this2.$message.error(err.msg || '获取商品折线图数据失败');
      });
    },
    // 获取商品分类饼图数据
    getProductCategoryPieData: function getProductCategoryPieData() {
      var _this3 = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getProductCategoryPieDataApi)(param).then(function (res) {
        _this3.productCategoryOption.series[0].data = res;
        _this3.productCategoryLoading = false;
      }).catch(function (err) {
        _this3.$message.error(err.msg || '获取商品分类饼图数据失败');
      });
    },
    // 获取商品类型饼图数据
    getProductTypePieData: function getProductTypePieData() {
      var _this4 = this;
      var param = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      (0, _dashboard.getProductTypePieDataApi)(param).then(function (res) {
        _this4.productTypeOption.series[0].data = res;
        _this4.productTypeLoading = false;
      }).catch(function (err) {
        _this4.$message.error(err.msg || '获取商品类型饼图数据失败');
      });
    },
    // 日期范围更改
    dateRangeChange: function dateRangeChange(timeVal) {
      this.productLineLoading = true;
      this.startTime = timeVal[0];
      this.endTime = timeVal[1];
      if (timeVal && timeVal[0] == timeVal[1]) {
        this.productLineOption.series.forEach(function (item, index) {
          item.symbol = 'circle';
        });
      } else {
        this.productLineOption.series.forEach(function (item, index) {
          item.symbol = 'none';
        });
      }
      // 获取商品统计数据
      this.getProductStatisticsData();
      // 获取商品折线图数据
      this.getProductLineData();
    }
  }
};